/* eslint-disable no-shadow */
export enum ContextType {
  email = 'email',
  sms = 'sms',
}
